import { defineMessages } from 'react-intl';

export default defineMessages({
	handoffHeader: {
		id: 'newMemberOffer.welcome.title',
		defaultMessage: 'Welcome to Calm Premium!',
		description: 'Welcome message for members with Calm Premium subscriptions',
	},
	handoffDescription: {
		id: 'newMemberOffer.welcome.description',
		defaultMessage:
			'You now have access to our full suite of life-changing tools to help you stress less and sleep better. Download our mobile app to continue listening.',
		description: 'Welcome message for members with Calm Premium subscriptions',
	},
	maybeLater: {
		id: 'onboarding.mobileHandoff.maybeLater',
		defaultMessage: 'Maybe later',
		description: 'Secondary cta',
	},
	scanQR: {
		id: 'app.mobileHandoff.share',
		defaultMessage: 'Scan this QR code to {br} download Calm:',
		description: 'Note to inform the user what happens when scanning the code',
	},
});
